import { Task, TaskDraft, TaskTransition, TaskUpdate } from '../types/task';
import baseApi from './baseApi';

const tasksApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTasksByClient: build.query({
      query: (clientId: number) => ({
        url: `/tasks/byClient/${clientId}`,
        method: 'GET',
      }),
      transformResponse: (response: Task[]) => response,
    }),
    getTasksAssignedByUser: build.query({
      query: () => ({
        url: `/tasks/assignedByUser`,
        method: 'GET',
      }),
      transformResponse: (response: Task[]) => response,
    }),
    createTask: build.mutation({
      query: (body: TaskDraft) => ({
        url: `/tasks`,
        method: 'POST',
        body,
      }),
      transformResponse: (response: Task) => response,
    }),
    updateTask: build.mutation({
      query: ({ taskId, ...body }: TaskUpdate & { taskId: number }) => ({
        url: `/tasks/${taskId}`,
        method: 'PATCH',
        body,
      }),
      transformResponse: (response: Task) => response,
    }),
    transitionTask: build.mutation({
      query: ({ taskId, event }: { taskId: number; event: TaskTransition['event'] }) => ({
        url: `/tasks/${taskId}/transition`,
        method: 'POST',
        body: { event },
      }),
      transformResponse: (response: Task) => response,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTasksByClientQuery,
  useGetTasksAssignedByUserQuery,
  useCreateTaskMutation,
  useUpdateTaskMutation,
  useTransitionTaskMutation,
} = tasksApi;
